export default "__VITE_ASSET__95fe3ffb__"